import { Injectable } from '@angular/core';
import {MatStepper} from '@angular/material';
import {Step} from '../models/StepModel';

@Injectable({
  providedIn: 'root'
})
export class MatStepperServiceService {
  nombreMaxSinistresADeclarer = 5;
  stepsIndexes: string[];
  defaultStepsIndexes: Step[];

  navigationStepsIndexes: Step[];
  constructor() {
   this.stepsIndexes = ['dateMec', 'marque', 'model', 'alimentation', 'chevaux', 'carrosserie', 'version', 'stationnement', 'usage',
      'codePostalPro', 'kilometrage', 'financement', 'remorque', 'isVehiculeActuellementAssure', 'isVehiculeAmenagePMR',
      'eteAssure36DerniersMois', 'bonusMalus', 'nbrAnneeBonusCinquante',
      'periodeAssure36DerniersMois', 'eteResilie36DerniersMois', 'motifResiliation36DerniersMois', 'dureeNonPaiement',
      'nombreAssureursResiliationNonPaiement', 'recidiveResiliationNonPaiement', 'contentieuxSoldeResiliationNonPaiement',
     'dateResiliation36DerniersMois', 'isEuSinistres36DerniersMois'];
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {this.stepsIndexes.push('natureSinistres36DerniersMois_' + i); }
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {this.stepsIndexes.push('isDelitDeFuiteSinistres36DerniersMois_' + i); }
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {this.stepsIndexes.push('isInterventionForceDeLOrdreSinistres36DerniersMois_' + i); }
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {this.stepsIndexes.push('poursuiteTribunalPoliceSinistres36DerniersMois_' + i); }
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {this.stepsIndexes.push('isPresenceTiersSinistres36DerniersMois_' + i); }
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {this.stepsIndexes.push('dateSinistre36DerniersMois_' + i); }
   this.stepsIndexes.push('isEuSanctionsPenalesOuAdministratives');
   this.stepsIndexes.push('isEuAlcoolemie36DerniersMois');
   this.stepsIndexes.push('dateDernierAlcoolemie36DerniersMois');
   this.stepsIndexes.push('isRefusTestAlcoolemie36DerniersMois');
   this.stepsIndexes.push('isDelitDeFuiteAlcoolemie36DerniersMois');
   this.stepsIndexes.push('controleAlcoolemieSuiteA36DerniersMois');
   this.stepsIndexes.push('controleAlcoolemieMethode36DerniersMois');
   this.stepsIndexes.push('tauxAlcoolemie36DerniersMois');
   this.stepsIndexes.push('isEuStupefiant36DerniersMois');
   this.stepsIndexes.push('dateDernierStupefiant36DerniersMois');
   this.stepsIndexes.push('isRefusTestStupefiant36DerniersMois');
   this.stepsIndexes.push('isDelitDeFuiteStupefiant36DerniersMois');
   this.stepsIndexes.push('controleStupefiantSuiteA36DerniersMois');
   this.stepsIndexes.push('controleStupefiantMethode36DerniersMois');
   this.stepsIndexes.push('isAnnulationOuSuspensionPermis36DerniersMois');
   this.stepsIndexes.push('annulationPermisAvecOuSansSinistre36DerniersMois');
   this.stepsIndexes.push('dateInitialPermisApresAnnulation');
   this.stepsIndexes.push('annulationPermisMotif36DerniersMois');
   this.stepsIndexes.push('dateAnnulationPermis36DerniersMois');
   this.stepsIndexes.push('suspensionPermisMotif36DerniersMois');
   this.stepsIndexes.push('dateSuspensionPermis36DerniersMois');
   this.stepsIndexes.push('nombreSuspensionPermis36AvecSinistreDerniersMois');
   this.stepsIndexes.push('nombreSuspensionPermis36SansSinistreDerniersMois');
   this.stepsIndexes.push('nombreMoisSuspensionPermis36DerniersMois');
   this.stepsIndexes.push('dateInfractionPermis36DerniersMois');
   this.stepsIndexes.push('dateSanctionPermis36DerniersMois');
   this.stepsIndexes.push('dureeSanction36DerniersMois');
   this.stepsIndexes.push('civiliteConducteurPrincipale');
   this.stepsIndexes.push('nomConducteurPrincipale');
   this.stepsIndexes.push('dateNaissanceConducteurPrincipal');
   this.stepsIndexes.push('datePermisConducteurPrincipal');
   this.stepsIndexes.push('typePermisConducteurPrincipal');
   this.stepsIndexes.push('paysConduiteHorsEuropeConducteurPrincipal');
   this.stepsIndexes.push('titulaireCarteGrise');
   this.stepsIndexes.push('situationFamilialeConducteurPrincipal');
   this.stepsIndexes.push('lienAvecConducteurPrincipal');
   this.stepsIndexes.push('professionConducteurPrincipal');
   this.stepsIndexes.push('adresseConducteurPrincipal');
   this.stepsIndexes.push('contactConducteurPrincipal');
   this.stepsIndexes.push('garantieSouhaiteeConducteurPrincipal');
   this.stepsIndexes.push('isAjouterConducteurSecondair');
   // this.stepsIndexes.push('isAssure36DerniersMoisConducteurSecondaire');
   this.stepsIndexes.push('confirmation');
   // this.stepsIndexes.forEach((item, index, array) => console.log(index + ' => ' + item));
   this.defaultStepsIndexes = [
      new Step('dateMec', 'marque', null),
      new Step('marque', 'model', 'dateMec'),
      new Step('model', 'alimentation', 'marque'),
      new Step('alimentation', 'chevaux', 'model'),
      new Step('chevaux', 'carrosserie', 'alimentation'),
      new Step('carrosserie', 'version', 'chevaux'),
      new Step('version', 'stationnement', 'carrosserie'),
      new Step('stationnement', 'usage', 'version'),
      new Step('usage', 'kilometrage', 'stationnement'),
      new Step('codePostalPro', 'kilometrage', 'usage'),
      new Step('kilometrage', 'financement', 'usage'),
      new Step('financement', 'remorque', 'kilometrage'),
      new Step('remorque', 'isVehiculeActuellementAssure', 'financement'),
      new Step('isVehiculeActuellementAssure', 'isVehiculeAmenagePMR', 'remorque'),
      new Step('isVehiculeAmenagePMR', 'eteAssure36DerniersMois', 'isVehiculeActuellementAssure'),
      new Step('eteAssure36DerniersMois', 'bonusMalus', 'remorque'),
      new Step('bonusMalus', 'periodeAssure36DerniersMois', 'eteAssure36DerniersMois'),
      new Step('nbrAnneeBonusCinquante', 'periodeAssure36DerniersMois', 'bonusMalus'),
      new Step('periodeAssure36DerniersMois', 'eteResilie36DerniersMois', 'bonusMalus'),
      new Step('eteResilie36DerniersMois', 'motifResiliation36DerniersMois', 'periodeAssure36DerniersMois'),
      new Step('motifResiliation36DerniersMois', 'dateResiliation36DerniersMois', 'eteResilie36DerniersMois'),
      new Step('dureeNonPaiement', 'nombreAssureursResiliationNonPaiement', 'motifResiliation36DerniersMois'),
      new Step('nombreAssureursResiliationNonPaiement', 'dateResiliation36DerniersMois', 'dureeNonPaiement'),
      new Step('recidiveResiliationNonPaiement', '', 'nombreAssureursResiliationNonPaiement'),
      new Step('contentieuxSoldeResiliationNonPaiement', '', 'recidiveResiliationNonPaiement'),
      new Step('dateResiliation36DerniersMois', 'isEuSinistres36DerniersMois', 'nombreAssureursResiliationNonPaiement'),
      new Step('isEuSinistres36DerniersMois', 'natureSinistres36DerniersMois_0', 'dateResiliation36DerniersMois'),
    ];
   for (let i = 0; i < this.nombreMaxSinistresADeclarer; i++) {
     this.defaultStepsIndexes.push(new Step('natureSinistres36DerniersMois_' + i, 'dateSinistre36DerniersMois_' + i, 'dateSinistre36DerniersMois_' + (i - 1)),
       new Step('isDelitDeFuiteSinistres36DerniersMois_' + i, 'dateSinistre36DerniersMois_' + i, 'natureSinistres36DerniersMois_' + i),
       new Step('isInterventionForceDeLOrdreSinistres36DerniersMois_' + i, 'isPresenceTiersSinistres36DerniersMois_' + i, 'natureSinistres36DerniersMois_' + i),
       new Step('poursuiteTribunalPoliceSinistres36DerniersMois_' + i, 'isPresenceTiersSinistres36DerniersMois_' + i, 'isInterventionForceDeLOrdreSinistres36DerniersMois_' + i),
       new Step('isPresenceTiersSinistres36DerniersMois_' + i, 'dateSinistre36DerniersMois_' + i, 'isDelitDeFuiteSinistres36DerniersMois_' + i),
       new Step('dateSinistre36DerniersMois_' + i, 'natureSinistres36DerniersMois_' + (i + 1), 'natureSinistres36DerniersMois_' + i));
   }
   this.defaultStepsIndexes.push(new Step('isEuSanctionsPenalesOuAdministratives', null, 'dateSinistre36DerniersMois_0'));
   this.defaultStepsIndexes.push(new Step('isEuAlcoolemie36DerniersMois', 'dateDernierAlcoolemie36DerniersMois', 'isEuSanctionsPenalesOuAdministratives'));
   this.defaultStepsIndexes.push(new Step('dateDernierAlcoolemie36DerniersMois', 'controleAlcoolemieSuiteA36DerniersMois', 'isEuAlcoolemie36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('isRefusTestAlcoolemie36DerniersMois', 'isDelitDeFuiteAlcoolemie36DerniersMois', 'controleAlcoolemieMethode36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('isDelitDeFuiteAlcoolemie36DerniersMois', 'isEuStupefiant36DerniersMois', 'isRefusTestAlcoolemie36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('controleAlcoolemieSuiteA36DerniersMois', 'controleAlcoolemieMethode36DerniersMois', 'dateDernierAlcoolemie36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('controleAlcoolemieMethode36DerniersMois', 'isRefusTestAlcoolemie36DerniersMois', 'controleAlcoolemieSuiteA36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('tauxAlcoolemie36DerniersMois', 'isEuStupefiant36DerniersMois', 'isDelitDeFuiteAlcoolemie36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('isEuStupefiant36DerniersMois', 'dateDernierStupefiant36DerniersMois', 'tauxAlcoolemie36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('dateDernierStupefiant36DerniersMois', 'controleStupefiantSuiteA36DerniersMois', 'isEuStupefiant36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('isRefusTestStupefiant36DerniersMois', 'isDelitDeFuiteStupefiant36DerniersMois', 'controleStupefiantMethode36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('isDelitDeFuiteStupefiant36DerniersMois', 'isAnnulationOuSuspensionPermis36DerniersMois', 'isRefusTestStupefiant36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('controleStupefiantSuiteA36DerniersMois', '', 'dateDernierStupefiant36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('controleStupefiantMethode36DerniersMois', 'isRefusTestStupefiant36DerniersMois', 'controleStupefiantSuiteA36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('isAnnulationOuSuspensionPermis36DerniersMois', null, 'isEuStupefiant36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('annulationPermisAvecOuSansSinistre36DerniersMois', null, 'isAnnulationOuSuspensionPermis36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('dateInitialPermisApresAnnulation', null, 'annulationPermisMotif36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('annulationPermisMotif36DerniersMois', null, 'annulationPermisAvecOuSansSinistre36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('dateAnnulationPermis36DerniersMois', null, 'annulationPermisMotif36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('suspensionPermisMotif36DerniersMois', null, 'isAnnulationOuSuspensionPermis36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('dateSuspensionPermis36DerniersMois', null, 'suspensionPermisMotif36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('nombreSuspensionPermis36AvecSinistreDerniersMois', null, 'nombreSuspensionPermis36SansSinistreDerniersMois'));
   this.defaultStepsIndexes.push(new Step('nombreSuspensionPermis36SansSinistreDerniersMois', null, 'nombreMoisSuspensionPermis36DerniersMois'));
   this.defaultStepsIndexes.push(new Step('nombreMoisSuspensionPermis36DerniersMois', null, 'isAssure36DerniersMoisConducteurSecondaire'));
   this.defaultStepsIndexes.push(new Step('dateInfractionPermis36DerniersMois', null, 'isAssure36DerniersMoisConducteurSecondaire'));
   this.defaultStepsIndexes.push(new Step('dateSanctionPermis36DerniersMois', null, 'isAssure36DerniersMoisConducteurSecondaire'));
   this.defaultStepsIndexes.push(new Step('dureeSanction36DerniersMois', null, 'isAssure36DerniersMoisConducteurSecondaire'));
   this.defaultStepsIndexes.push(new Step('civiliteConducteurPrincipale', null, null));
   this.defaultStepsIndexes.push(new Step('nomConducteurPrincipale', null, null));
   this.defaultStepsIndexes.push(new Step('dateNaissanceConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('datePermisConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('typePermisConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('paysConduiteHorsEuropeConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('titulaireCarteGrise', null, null));
   this.defaultStepsIndexes.push(new Step('situationFamilialeConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('lienAvecConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('professionConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('adresseConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('contactConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('garantieSouhaiteeConducteurPrincipal', null, null));
   this.defaultStepsIndexes.push(new Step('isAjouterConducteurSecondair', null , null));
   this.defaultStepsIndexes.push(new Step('confirmation', null, null));

   this.navigationStepsIndexes = [...this.defaultStepsIndexes];
   this.updatePreviousStep('natureSinistres36DerniersMois_0', 'isEuSinistres36DerniersMois');

  }
  getIndexByStepKey(stepKey: string): number {
    return this.stepsIndexes.indexOf(stepKey);
  }
  // getStepKeyByIndex(index: number): string {return this.defaultStepsIndexes[index].stepKey; }
  getStepKeyByIndex(index: number): string {return this.stepsIndexes[index]; }
  updatePreviousStep(stepKey: string, newPreviousStepKey: string) {
    this.navigationStepsIndexes.find(step => step.stepKey === stepKey ).previousStepKey = newPreviousStepKey;
  }
  updateNextStep(stepKey: string, newNextStepKey: string) {
    this.navigationStepsIndexes.find(step => step.stepKey === stepKey ).nextStepKey = newNextStepKey;
  }
  getPreviousIndexByStepKey(stepKey: string ): number {
    return this.getIndexByStepKey(this.navigationStepsIndexes.find(step => step.stepKey === stepKey ).previousStepKey);
  }
  // return next step index, ex : nextLevel 2 => 2 steps after
  getNextIndexByStepKey(stepKey: string, nextLevel: number): number {
    if (nextLevel === 0) {
      return this.getIndexByStepKey(stepKey);
    }
    return this.getNextIndexByStepKey(this.navigationStepsIndexes.find(step => step.stepKey === stepKey ).nextStepKey, nextLevel - 1);
  }
  goToIndex(stepper: MatStepper, index: number) {
    stepper.selectedIndex = index;
  }
  goForward(stepper: MatStepper, nextIndex: number) {
    this.goToIndex(stepper, nextIndex);
  }
  goBack(stepper: MatStepper, currentStepKey: string) {
    this.goToIndex(stepper, this.getPreviousIndexByStepKey(currentStepKey));
  }


}
